<template>
   <div class="slick-wrapper">
    <slot></slot>
  </div>
</template>

<script>

/**
 * ==================================
 *  Slick Slideshow Vue.js Component
 * ==================================
 *
 * <slick
 *        :autoplay="true|false"
 *        :pause-on-hover="true|false"
 * >...</slick>
 */

import TweenLite from 'gsap'
import { mapGetters } from 'vuex';

export default {
  props: {
    // Be sure to specify with a :vue prop like:
    // <slick :autoplay="true">
    // pass :options="{ setAppendArrows: true, setAppendDots: true }" to set custom el for dots and/or arrows. use setAppendPaging: true to add paging to the gallery
    autoplay: {
      default: false,
      type: Boolean
    },
    pauseOnHover: {
      default: false,
      type: Boolean
    },
    speed: {
        default: 1500,
        type: Number
    },
    slideTotal: {
        default: 0,
        type: Number
    },
    dots: {
      type: Boolean,
      default: true
    },
    options: {
      type: Object,
      default: () => {
        return {};
      }
    },
    modalOpen: {},
    phone: {
      type: Boolean,
      default: false
    }
  },

  data: function() {
    return {
      slick: false,
      el: false,
      viewport: 0,
      reset: false,
      svgArrowPrev: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 20"><path d="M10 2.35L8.0972 0 0 10l8.0972 10L10 17.65 3.8192 10z"/></svg>`,
      svgArrowNext: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 20"><path d="M0 2.35L1.9028 0 10 10 1.9028 20 0 17.65 6.1808 10z"/></svg>`
    }
  },

  mounted: function() {
    const $el = $(this.$el);
    let htmlPaging = `<div class="gallery-paging">1 of ${this.numSlides}</div>`;
    let prevArrow = `<button type="button" class="slick-arrow slick-prev">${this.svgArrowPrev}</button>`;
    let nextArrow = `<button type="button" class="slick-arrow slick-next">${this.svgArrowNext}</button>`;

    $el.slick({
      speed: 500,
      dots: this.dots,
      autoplay: this.autoplay,
      autoplaySpeed: this.speed,
      pauseOnHover: this.pauseOnHover,
      prevArrow: this.options.setAppendPaging ? prevArrow + htmlPaging : prevArrow,
      nextArrow: nextArrow,
      appendArrows: this.options.setAppendArrows ? $(".slider-navigation") : $(this.$el),
      appendDots: this.options.setAppendDots ? $(".slider-dots") : $(this.$el),
      ...this.options,
    })

    this.slick = $el.slick;

    // pause slideshow on click, and make it sticky
    $el.on('click', function() {
      this.slick.slickPause();
    });

    $el.on('reInit beforeChange', (event, slick, currentSlide, nextSlide) => {
        if (this.numSlides > 0) {
          const paging = this.$el.parentElement.querySelector('.gallery-paging');
          if (paging) {
            $(paging).text(`${nextSlide + 1} of ${this.numSlides}`);
          }
        }
    });


    TweenLite.fromTo($el, 1, {opacity: 0 }, {opacity: 1 });
  },
  computed: {
    numSlides() {
      let count = 0;
      if (this.$slots.default) {
        this.$slots.default.forEach(val => {
          if (val.context) {
            count++;
          }
        });
      }
      return count;
    },
    ...mapGetters({
      getData: 'slick/getData'
    }),


    modalImageIndex() {
      return this.getData.modalImageIndex;
    }
  },
  watch: {
    // need this one or watch will fire before slick is initialized.
    modalImageIndex: {
      immediate: true,
      handler(value){
          this.$nextTick(() => {
            if (this.slick) {
              $(this.$el).slick('slickGoTo', value, true);
            }
          });

      }
    },
    getData: function() {
      if (this.slick) {
        this.$nextTick(() => {
          $(this.$el).slick('getSlick').refresh();
        });
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/components/vendor/slick.vue